import Jsona from "jsona";
import HTTP from "../http";
import cycleMixin from "@/mixins/cycleMixin";

const dataFormatter = new Jsona();

const SHALLOW_LIST_RELATION = [
  "orders.schedule_event",
  "subscription.professional.account.profile",
  "subscription.address",
  "payments.funding_instrument"
];

export default {
  async show(id) {
    try {
      let results = await HTTP.normal.get(
        `/cycles/${id}/?include=orders.schedule_event,orders.professional,subscription.address.district.city.state.country,subscription.professional.account.profile,subscription.professional.account.schedule,subscription.customer.account.profile,payments.funding_instrument,amount.subtotal`
      );

      results = dataFormatter.deserialize(results.data);

      results["address"] = results.subscription.address;
      results["professional"] = results.subscription.professional;
      results["customer"] = results.subscription.customer;

      return results;
    } catch (e) {
      throw "Ocorreu um erro ao buscar o ciclo!";
    }
  },

  async searchWithPendingPayment() {
    try {
      let results = await HTTP.normal.get(
        "/cycles?filter[status]=created_on_gateway,payment_requested,waiting_payment"
      );
      return (results = dataFormatter.deserialize(results.data));
    } catch (e) {
      throw "Ocorreu um erro ao buscar os ciclos com pagamentos pendentes!";
    }
  },

  async cyclePendingPayment() {
    const pendingPaymentStatuses = cycleMixin.methods.statesToCheckout();

    const pendingOrders = await HTTP.normal.get(
      `/cycles?include=${SHALLOW_LIST_RELATION.join(
        ","
      )}&filter[status]=${pendingPaymentStatuses.join(",")}&sort=-created_at`
    );

    return dataFormatter.deserialize(pendingOrders.data);
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/cycles.js